// This object is used to manage and store data locally
jQuery(function( $ ) {
	'use strict'

    window.LocalStorageManager = {

		// set to true to show debug messages in the console log
		showLocalStorageDebugLog: false,

		// returns a promise that is resolved once the data is loaded.
		loadField: function( fieldName, lifespan ) {
			// context for use in inner anonymous functions
			const _this = this;

			if ( this.showLocalStorageDebugLog ) {
				console.log( 'LocalStorageManager.loadField( ' + fieldName + ' )' );
			}

            return new Promise( function( resolve, reject ) {
                window.ajaxCall({
					loadingMessage: 'Loading ' + fieldName + ' data',
					successMessage: 'Successfully loaded ' + fieldName + ' data',
					warningMessage: 'Error while loading ' + fieldName + ' data',
                    data : {
                        action: 'get_' + fieldName,
                    },
                    successMessage: 'Successfully Loaded ' + fieldName,
                    onSuccess : function( response ) {
						const data = response.data[ fieldName ];
						_this.set( fieldName, data );
						_this.populateStore( fieldName );
                        resolve();
                    },
                    onError : function ( response ) {
						const message = 'Failed to load field ' + fieldName + ' in LocalStorageManager';
                        console.error( message );
						_this.removeField( fieldName );
                        reject( message );
                    }
                });
            });
        },

		// Remove all data from LocalStorage
		clear: function() {
			localStorage.clear();
		},

		// Remove data from LocalStorage
		removeField: function( fieldName ) {
			if ( this.showLocalStorageDebugLog ) {
				console.log( 'LocalStorageManager.removeField( ' + fieldName + ' )' );
			}

			localStorage.removeItem( fieldName );
		},

		// Return the data from local storage
        get: function( fieldName ) {
			const data = JSON.parse( localStorage.getItem( fieldName ) );

			if ( this.showLocalStorageDebugLog ) {
				console.log( 'LocalStorageManager.get( ' + fieldName + ' )' );
				console.log( data );
			}

			return data;
        },

		// Set the data in local storage
		set: function( fieldName, data ) {
			if ( this.showLocalStorageDebugLog ) {
				console.log( 'LocalStorageManager.set( ' + fieldName + ' ):' );
				console.log( data );
			}

			localStorage.setItem( fieldName, JSON.stringify( data ) );
		},

		// Populate the store with data from local storage
		populateStore: function( fieldName ) {
			if ( this.showLocalStorageDebugLog ) {
				console.log( 'LocalStorageManager.populateStore( ' + fieldName + ' )' );
			}

			store.commit( 'set', { fieldName: fieldName, value: this.get( fieldName ) } );
		},

		// remove field from storage and reload it
		updateField: function( fieldName ) {
			if ( this.showLocalStorageDebugLog ) {
				console.log( 'LocalStorageManager.updateField( ' + fieldName + ' )' );
			}

			LocalStorageManager.removeField( fieldName );
			LocalStorageManager.loadField( fieldName );
		},

	};

});
